import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  saveCategoryRequest,
  clearEditCategoryStepper,
  clearEditCategory,
} from '../../../redux/categories/actions';

import CreationModal from './CreationModal';

const mapStateToProps = state => ({
  isLoading: state.categories.isLoading,
  saveStatus: state.categories.saveStatus,
  saveError: state.categories.saveError,
  category: state.categories.category,
});

const mapDispatchToProps = dispatch => ({
  saveCategoryRequest: payload => dispatch(saveCategoryRequest(payload)),
  clearEditCategoryStepper: () => dispatch(clearEditCategoryStepper()),
  clearEditCategory: () => dispatch(clearEditCategory()),
});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CreationModal),
);
